export enum AnswerVisibilityType {
  AFTER_QUESTION = "after-question",
  AFTER_COMPLETED = "after-completed",
  AFTER_CLOSE = "after-close",
  DONT_SHARE = "none",
}
